export const NOTE_ANCHOR_TYPES = {
  FARM: 'farm',
  SECTION: 'section',
  LAYER: 'layer',
  LAYER_FEATURE: 'layer_feature',
};
